import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";

import styles from "./BlachnioModal.module.scss";
import { messages } from "../Case1TechnicalPov.messages";
import { useUi } from "@jelly/lesson";

type BioNoteModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;
export const GirresModal: React.FC<BioNoteModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props} title={formatMessage(messages.interviews4Title)}>
      <div className={styles.slide}>
        <div className={styles.content}>{formatMessage(messages.interviews4BioNote)}</div>
      </div>
    </ui.Modal>
  );
};

//TODO: override scrollbars colors
